import { render, staticRenderFns } from "./Invita.vue?vue&type=template&id=11844116&scoped=true"
import script from "./Invita.vue?vue&type=script&lang=js"
export * from "./Invita.vue?vue&type=script&lang=js"
import style0 from "./Invita.vue?vue&type=style&index=0&id=11844116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11844116",
  null
  
)

export default component.exports